import { render, staticRenderFns } from "./healthy.vue?vue&type=template&id=717be169&"
import script from "./healthy.vue?vue&type=script&lang=js&"
export * from "./healthy.vue?vue&type=script&lang=js&"
import style0 from "./healthy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports